{
  "version": 1,
  "asset_id": "1f57c764-6eb4-491f-9331-81f60bc7dca2",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/1f57c764-6eb4-491f-9331-81f60bc7dca2/ind-ecommerce-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/1f57c764-6eb4-491f-9331-81f60bc7dca2/ind-ecommerce-1200.avif",
  "original_filename": "ind-ecommerce-1200.avif",
  "size": 12547,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:01Z"
}
